export default __webpack_public_path__ + "static/media/Bestand_Papier.2457649b.png";